export const GARMENT_SUMMONING_LIMIT = 200